<template>
  <date-picker
    v-model="dateValue"
    :model-config="returnFormat"
    :locale="locale"
    :masks="{input: showFormat,}"
    :timezone="timezone"
    :mode="mode"
    v-bind="otherProps"
  >
    <template v-slot="{ inputValue, togglePopover }">
      <input
        :placeholder="placeholder"
        class="bg-white form-control border px-2 py-1 rounded"
        :value="typeof inputValue === 'string' ? inputValue : `${inputValue.start || ''}-${inputValue.end || ''}`"
        :disabled="disabled"
        :readonly="readonly"
        @click="togglePopover()"
      >
    </template>
  </date-picker>
  <!-- for example -->

  <!--
      <vue-date-picker
        v-model="date"
        placeholder="sdfsdf"
        :return-format="{ type: 'string', mask: 'YYYY-MM-DD' }"
        show-format="DD.MM.YYYY"
      />
  -->
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  components: {
    DatePicker,
  },
  props: {
    // !
    value: {
      type: [String, Object],
      required: false,
      default: '',
    },
    // all Props
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    timezone: {
      type: String,
      required: false,
      default: '',
    },
    locale: {
      type: [String, Object],
      required: false,
      default: 'ru',
    },
    returnFormat: {
      type: Object,
      required: false,
      default: () => ({ type: 'string', mask: 'YYYY-MM-DD' }),
    },
    showFormat: {
      type: String,
      required: false,
      default: 'DD.MM.YYYY',
    },
    mode: {
      type: String,
      required: false,
      default: 'date',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: true,
    },
    otherProps: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      dateValue: this.value,
    }
  },
  watch: {
    dateValue(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style>

</style>
